import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { balanceOfHealth } from "@/helper/contractFunctions/MafiaHealth";
import { buyHealth, claimHospitalProfit, getHealthMarketUpdateInterval, getCityHospitalInfo, getNextHealthBuyTime, reproduceBlood } from "@/helper/contractFunctions/MafiaHospital";

export interface HospitalState {
  healthBalance: number;
  nextHealthBuyTime: number;
  healthMarketInfo: { price: number; amountLeft: number; lastUpdateTime: number };
  isLoadingHealthMarketInfo: boolean;
  healthMarketLaunchBlock: number;
  healthMarketUpdateInterval: number;
  isBuyingHealth: boolean;
  isProducingHealth: boolean;
}
const initialState: HospitalState = {
  healthBalance: 0,
  nextHealthBuyTime: 0,
  healthMarketInfo: { price: 0, amountLeft: 0, lastUpdateTime: 0 },
  isLoadingHealthMarketInfo: false,
  healthMarketLaunchBlock: 0,
  healthMarketUpdateInterval: 200,
  isBuyingHealth: false,
  isProducingHealth: false,
};
export const getHealthBalance = createAsyncThunk("hospital/getHealthBalance", async ({ account, signMsg, signature }: { account: string; signMsg: string; signature: string }) => Number(await balanceOfHealth(account, signMsg, signature)));
export const getCityHospitalInfoAction = createAsyncThunk("hospital/getCityHospitalInfoAction", async ({ cityId }: { cityId: number }) => getCityHospitalInfo(cityId));
export const reproduceBloodAction = createAsyncThunk("hospital/reproduceBloodAction", async ({ account, cityId }: { account: string; cityId: number }) => (await reproduceBlood(account, cityId)).transactionHash);
export const claimHospitalProfitAction = createAsyncThunk("hospital/claimHospitalProfitAction", async ({ account, cityId }: { account: string; cityId: number }) => (await claimHospitalProfit(account, cityId)).transactionHash);
export const getNextHealthBuyTimeAction = createAsyncThunk("hospital/getNextHealthBuyTimeAction", getNextHealthBuyTime);
export const getHealthMarketUpdateIntervalAction = createAsyncThunk("hospital/getHealthMarketUpdateIntervalAction", getHealthMarketUpdateInterval);
export const buyHealthAction = createAsyncThunk("hospital/buyHealthAction", async ({ account, healthAmount, message, signature }: { account: string; healthAmount: number; message: string; signature: string }) => (await buyHealth(account, healthAmount, message, signature)).transactionHash);

const hospitalSlice = createSlice({
  name: "hospital", initialState, reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHealthBalance.fulfilled, (state, { payload }) => { state.healthBalance = payload; })
      .addCase(reproduceBloodAction.pending, (state) => { state.isProducingHealth = true; })
      .addCase(reproduceBloodAction.fulfilled, (state) => { state.isProducingHealth = false; })
      .addCase(reproduceBloodAction.rejected, (state) => { state.isProducingHealth = false; })
      .addCase(buyHealthAction.pending, (state) => { state.isBuyingHealth = true; })
      .addCase(buyHealthAction.fulfilled, (state) => { state.isBuyingHealth = false; })
      .addCase(buyHealthAction.rejected, (state) => { state.isBuyingHealth = false; })
      .addCase(getCityHospitalInfoAction.pending, (state) => { state.isLoadingHealthMarketInfo = true; })
      .addCase(getCityHospitalInfoAction.fulfilled, (state, { payload }) => { state.healthMarketInfo = payload; state.isLoadingHealthMarketInfo = false; })
      .addCase(getCityHospitalInfoAction.rejected, (state) => { state.isLoadingHealthMarketInfo = false; })
      .addCase(getNextHealthBuyTimeAction.fulfilled, (state, { payload }) => { state.nextHealthBuyTime = payload; })
      .addCase(getNextHealthBuyTimeAction.rejected, (state) => { state.nextHealthBuyTime = -1; })
      .addCase(getHealthMarketUpdateIntervalAction.fulfilled, (state, { payload }) => { state.healthMarketUpdateInterval = payload; });
  },
});
export default hospitalSlice.reducer;